export const COMMON = {
	RESET_FIELD: "RESET_FIELD"
};

export const UI = {
	TOGGLE_PRELOADER: "TOGGLE_PRELOADER",
	TOGGLE_AT_BOTTOM: "TOGGLE_AT_BOTTOM"
};

export const SESSION = {
	SEND_LOGIN_CREDENTIALS: "SEND_LOGIN_CREDENTIALS",
	UPDATE_LOGIN_CREDENTIALS: "UPDATE_LOGIN_CREDENTIALS",
	SEND_FORGOT_PASSWORD_CREDENTIALS: "SEND_FORGOT_PASSWORD_CREDENTIALS",
	SEND_REGISTER_NOW_CREDENTIALS: "SEND_REGISTER_NOW_CREDENTIALS",
	SEND_RESET_PASSWORD_CREDENTIALS: "SEND_RESET_PASSWORD_CREDENTIALS",
	REQUEST_INFORMATION_OR_SCHEDULE_AN_APPOINTMENT: "REQUEST_INFORMATION_OR_SCHEDULE_AN_APPOINTMENT",
	SEND_SUBSCRIBE: "SEND_SUBSCRIBE"
};

export const RECIPES = {
	GET_RECIPES: "GET_RECIPES",
	DELETE_RECIPE: "DELETE_RECIPE",
	SEARCH_RECIPES: "SEARCH_RECIPES",
	RESET_RECIPES: "RESET_RECIPES",
	GET_AVAILABLE_FILTERS: "GET_AVAILABLE_FILTERS",
	RECIPE_DETAILS: "RECIPE_DETAILS",
	RELATED_RECIPES: "RELATED_RECIPES",
	RECIPE_NUTRITION_FACTS: "RECIPE_NUTRITION_FACTS",
	RECIPE_INGREDIENTS: "RECIPE_INGREDIENTS",
	GET_RECENT_RECIPES: "GET_RECENT_RECIPES",
	GET_RECIPE_COMMENTS: "GET_RECIPE_COMMENTS",
	ADD_RECIPE_COMMENT: "ADD_RECIPE_COMMENT",
	GET_FEATURED_RECIPES: "GET_FEATURED_RECIPES",
	APPROVE_RECIPE_COMMENT: "APPROVE_RECIPE_COMMENT",
	RECIPE_IS_FAVOURITE: "RECIPE_IS_FAVOURITE",
	RECIPE_SET_FAVOURITE: "RECIPE_SET_FAVOURITE",
	DECLINE_RECIPE: "DECLINE_RECIPE",
	GET_RECIPE_COMMENTS_APPROVAL: "GET_RECIPE_COMMENTS_APPROVAL",
	GET_RECIPES_FAVORITED: "GET_RECIPES_FAVORITED"
};

export const ADD_RECIPE = {
	SAVE_BASIC_DETAILS: "SAVE_BASIC_DETAILS",
	SAVE_INGREDIENTS: "SAVE_INGREDIENTS",
	SAVE_CATEGORIES: "SAVE_CATEGORIES",
	SAVE_IMAGES: "SAVE_IMAGES",
	SAVE_SOURCES: "SAVE_SOURCES",
	SEARCH_INGREDIENTS: "SEARCH_INGREDIENTS",
	GET_CATEGORY_GROUPS: "GET_CATEGORY_GROUPS",
	GET_RECIPE_CATEGORIES: "GET_RECIPE_CATEGORIES",
	ADD_RECIPE_CATEGORY: "ADD_RECIPE_CATEGORY",
	DELETE_RECIPE_CATEGORY: "DELETE_RECIPE_CATEGORY",
	GET_SOURCES: "GET_SOURCES",
	GET_RECIPE_SOURCES: "GET_RECIPE_SOURCES",
	ADD_RECIPE_SOURCES: "ADD_RECIPE_SOURCES",
	DELETE_RECIPE_SOURCE: "DELETE_RECIPE_SOURCE",
	GET_IMAGES: "GET_IMAGES",
	ADD_IMAGES: "ADD_IMAGES",
	GET_RECIPE_IMAGES: "GET_RECIPE_IMAGES",
	ADD_RECIPE_IMAGES: "ADD_RECIPE_IMAGES",
	DELETE_RECIPE_IMAGE: "DELETE_RECIPE_IMAGE",
	GET_FOOD_GROUP_LIST: "GET_FOOD_GROUP_LIST",
	GET_INGREDIENT_WEIGHTS_LIST: "GET_INGREDIENT_WEIGHTS_LIST",
	GET_RECIPE_INGREDIENTS: "GET_RECIPE_INGREDIENTS",
	ADD_RECIPE_INGREDIENTS: "ADD_RECIPE_INGREDIENTS",
	UPDATE_RECIPE_INGREDIENTS: "UPDATE_RECIPE_INGREDIENTS",
	DELETE_RECIPE_INGREDIENT: "DELETE_RECIPE_INGREDIENT",
	PUBLISH_RECIPE: "PUBLISH_RECIPE",
	SUBMIT_RECIPE: "SUBMIT_RECIPE",
	GET_CATEGORIES: "GET_CATEGORIES",
	CREATE_CATEGORY_GROUP: "CREATE_CATEGORY_GROUP",
	UPDATE_CATEGORY_GROUP: "UPDATE_CATEGORY_GROUP",
	DELETE_CATEGORY_GROUP: "DELETE_CATEGORY_GROUP",
	CREATE_CATEGORY: "CREATE_CATEGORY",
	UPDATE_CATEGORY: "UPDATE_CATEGORY",
	DELETE_CATEGORY: "DELETE_CATEGORY",
	CREATE_SOURCE: "CREATE_SOURCE",
	UPDATE_SOURCE: "UPDATE_SOURCE",
	DELETE_SOURCE: "DELETE_SOURCE"
};

export const FOOD_DATABASE = {
	GET_FOOD_DATABASE: "GET_FOOD_DATABASE",
	GET_FOOD_DATABASE_LEVEL_2: "GET_FOOD_DATABASE_LEVEL_2",
	GET_FOOD_DATABASE_LEVEL_3: "GET_FOOD_DATABASE_LEVEL_3",
	GET_FOOD_DATABASE_LEVEL_4: "GET_FOOD_DATABASE_LEVEL_4",
	GET_FOOD_LIST_CARD_VIEW: "GET_FOOD_LIST_CARD_VIEW",
	GET_FOOD_DETAILS: "GET_FOOD_DETAILS",
	GET_PATIENT_FOOD_DETAILS: "GET_PATIENT_FOOD_DETAILS",
	GET_FOOD_NUTRITION: "GET_FOOD_NUTRITION",
	GET_FOOD_APPROVAL_LIST: "GET_FOOD_APPROVAL_LIST",
	GET_NUT_DATA: "GET_NUT_DATA",
	DECLINE_FOOD: "DECLINE_FOOD",
	APPROVE_FOOD_ITEM: "APPROVE_FOOD_ITEM",
	SEARCH_PATIENT_FOOD: "SEARCH_PATIENT_FOOD",
	UPDATE_NUT_DATA: "UPDATE_NUT_DATA",
	SAVE_FOOD_DETAILS: "SAVE_FOOD_DETAILS",
	ADD_FOOD_ITEM: "ADD_FOOD_ITEM",
	GET_INGREDIENT_WEIGHTS: "GET_INGREDIENT_WEIGHTS",
	ADD_INGREDIENT_WEIGHTS: "ADD_INGREDIENT_WEIGHTS",
	UPDATE_INGREDIENT_WEIGHTS: "UPDATE_INGREDIENT_WEIGHTS",
	DELETE_INGREDIENT_WEIGHTS: "DELETE_INGREDIENT_WEIGHTS",
};


export const RESOURCES = {
	GET_RESOURCES: "GET_RESOURCES",
	RESET_RESOURCES: "RESET_RESOURCES",
	SEARCH_RESOURCES: "SEARCH_RESOURCES",
	GET_RESOURCE_DETAILS: "GET_RESOURCE_DETAILS",
	SELECTED_RESOURCE: "SELECTED_RESOURCE"
};

export const NUTRITION_JOURNAL = {
	GET_NUTRITION_JOURNAL_SUMMARY: "GET_NUTRITION_JOURNAL_SUMMARY",
	GET_NUTRITION_JOURNAL_ENTRIES: "GET_NUTRITION_JOURNAL_ENTRIES",
	ADD_NUTRITION_JOURNAL: "ADD_NUTRITION_JOURNAL",
	EDIT_NUTRITION_JOURNAL: "EDIT_NUTRITION_JOURNAL",
	DELETE_NUTRITION_JOURNAL: "DELETE_NUTRITION_JOURNAL",
	GET_NUTRITION_GOALS: "GET_NUTRITION_GOALS",
	SAVE_NUTRITION_GOALS: "SAVE_NUTRITION_GOALS",
	UPDATE_HYDRATION: "UPDATE_HYDRATION",
	CREATE_NUTRITION_GOALS: "CREATE_NUTRITION_GOALS"
};

export const EXERCISES = {
	GET_EXERCISES: "GET_EXERCISES",
	GET_EXERCISE_FILTERS: "GET_EXERCISE_FILTERS",
	EXERCISE_DETAILS: "EXERCISE_DETAILS",
	SEARCH_EXERCISES: "SEARCH_EXERCISES",
	EXERCISE_POTENTIAL_BURN: "EXERCISE_POTENTIAL_BURN",
	EXERCISE_RELATED: "EXERCISE_RELATED",
	ADD_EXERCISE_TO_WORKOUT: "ADD_EXERCISE_TO_WORKOUT",
	EDIT_EXERCISE: "EDIT_EXERCISE",
	DELETE_EXERCISES_FROM_PLAN: "DELETE_EXERCISES_FROM_PLAN",
	TOGGLE_ADD_EXERCISE_PANEL: "TOGGLE_ADD_EXERCISE_PANEL",
	TOGGLE_ADD_PLAN_PANEL: "TOGGLE_ADD_PLAN_PANEL",
	LOG_EXERCISE: "LOG_EXERCISE",
	EDIT_EXERCISE_SUMMARY: "EDIT_EXERCISE_SUMMARY",
	DELETE_EXERCISE_SUMMARY: "DELETE_EXERCISE_SUMMARY",
	LOG_EXERCISE_ALL: "LOG_EXERCISE_ALL",
	ADD_PLAN_TO_WORKOUT: "ADD_PLAN_TO_WORKOUT"
};

export const WORKOUT_PLANS = {
	GET_WORKOUT_PLANS: "GET_WORKOUT_PLANS",
	SEARCH_WORKOUT_PLANS: "SEARCH_WORKOUT_PLANS",
	GET_WORKOUT_PLAN_DETAILS: "GET_WORKOUT_PLAN_DETAILS",
	ADD_PLAN_TO_WORKOUT: "ADD_PLAN_TO_WORKOUT"
};

export const MY_WORKOUT = {
	GET_MY_WORKOUT: "GET_MY_WORKOUT",
	TOGGLE_SIDE_PANEL: "TOGGLE_SIDE_PANEL",
	TOGGLE_EDIT_PANEL: "TOGGLE_EDIT_PANEL",
	DELETE_MY_WORKOUTS: "DELETE_MY_WORKOUTS"
};

export const MY_PROGRESS = {
	GET_MY_PROGRESS_LIST: "GET_MY_PROGRESS_LIST",
	GET_MY_HISTORY_GRAPH: "GET_MY_HISTORY_GRAPH"
};

export const MY_HISTORY = {
	GET_SUMMARY: "GET_SUMMARY",
	GET_DETAILS: "GET_DETAILS"
};

export const HOME = {
	GET_HOME_DATA: "GET_HOME_DATA",
	GET_WEIGHT_HISTORY: "GET_WEIGHT_HISTORY",
	GET_ADS: "GET_ADS",
	GET_MOTIVATIONAL_VIDEOS: "GET_MOTIVATIONAL_VIDEOS"
};

export const PROGRESS = {
	GET_PROGRESS_CHARTS: "GET_PROGRESS_CHARTS",
	GET_PROGRESS_WEIGHT_HISTORY_LIST: "GET_PROGRESS_WEIGHT_HISTORY_LIST",
	GET_PROGRESS_MEMBERWEIGHT_HISTORY_LIST: "GET_PROGRESS_MEMBERWEIGHT_HISTORY_LIST",
	POST_ADD_WEIGHT: "POST_ADD_WEIGHT"
};

export const FITNESS_JOURNAL = {
	GET_FITNESS_JOURNAL_SUMMARY: "GET_FITNESS_JOURNAL_SUMMARY",
	GET_FITNESS_JOURNAL: "GET_FITNESS_JOURNAL",
	GET_FITNESS_GOALS: "GET_FITNESS_GOALS",
	SAVE_FITNESS_GOALS: "SAVE_FITNESS_GOALS",
	CREATE_FITNESS_JOURNAL: "CREATE_FITNESS_JOURNAL",
	EDIT_FITNESS_JOURNAL: "EDIT_FITNESS_JOURNAL",
	DELETE_FITNESS_JOURNAL: "DELETE_FITNESS_JOURNAL",
	CREATE_FITNESS_GOALS: "CREATE_FITNESS_GOALS"
};

export const AD_MANAGEMENT = {
	GET_ADS_LIST: "GET_ADS_LIST",
	ADD_NEW_AD_SUCCESS: "ADD_NEW_AD_SUCCESS",
	UPDATE_AD_SUCCESS: "UPDATE_AD_SUCCESS",
	DELETE_AD_SUCCESS: "DELETE_AD_SUCCESS"
};

export const MOTIVATION_MANAGEMENT = {
	GET_MOTIVATION_LIST: "GET_MOTIVATION_LIST",
	ADD_NEW_MOTIVATION_SUCCESS: "ADD_NEW_MOTIVATION_SUCCESS",
	UPDATE_MOTIVATION_SUCCESS: "UPDATE_MOTIVATION_SUCCESS",
	DELETE_MOTIVATION_SUCCESS: "DELETE_MOTIVATION_SUCCESS"
};

export const BADGES = {
	GET_BADGES: "GET_BADGES",
	GET_BADGE_DETAILS: "GET_BADGE_DETAILS"
};

export const TESTIMONIALS = {
	GET_TESTIMONIALS: "GET_TESTIMONIALS",
	ADD_TESTIMONIAL: "ADD_TESTIMONIAL",
	GET_COUNTRIES: "GET_COUNTRIES",
	GET_REPLACEMENTS: "GET_REPLACEMENTS",
	SUBMIT_TESTIMONIAL: "SUBMIT_TESTIMONIAL",
	GET_TESTIMONIAL_IMAGES: "GET_TESTIMONIAL_IMAGES",
	ADD_TESTIMONIAL_IMAGES: "ADD_TESTIMONIAL_IMAGES",
	DELETE_IMAGE: "DELETE_IMAGE",
	EDIT_TESTIMONIAL: "EDIT_TESTIMONIAL",
	DELETE_TESTIMONIAL: "DELETE_TESTIMONIAL",
	GET_TESTIMONIALS_DETAILS: "GET_TESTIMONIALS_DETAILS"
};

export const MY_FOOD = {
	GET_MY_FOOD_LIST: "GET_MY_FOOD_LIST",
	SAVE_MY_FOOD_ITEM: "SAVE_MY_FOOD_ITEM",
	DELETE_MY_FOOD_ITEM: "DELETE_MY_FOOD_ITEM"
}
